import { render, staticRenderFns } from "./AllowanceAdd.vue?vue&type=template&id=5cd26625&scoped=true&"
import script from "./AllowanceAdd.vue?vue&type=script&lang=js&"
export * from "./AllowanceAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd26625",
  null
  
)

export default component.exports